import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  status: PropTypes.string,
};

const StatusBadge = (props) => {
  return (
    <>
      <strong>
        {props.status == "open" && (
          <span className="badge rounded-pill open ">{props.status.toUpperCase()}</span>
        )}
        {props.status == "pending" && <span className="badge rounded-pill hold ">{"ON HOLD"}</span>}
        {props.status === "closed" && (
          <span className="badge rounded-pill closed">{props.status.toUpperCase()}</span>
        )}
      </strong>
    </>
  );
};

StatusBadge.propTypes = propTypes;

export default StatusBadge;
